<template>
    <LoginModal v-model:open="isOpen" :show-continue="false" :title="title">
        <AiAuthForm @success="onSuccess" @step-change="onStepChange" @photo-picker-requested="emits('photo-picker-requested')" />
    </LoginModal>
</template>

<script setup lang="ts">
import LoginModal from '@/components/modals/LoginModal.vue';
import AiAuthForm, { type AiAuthStep } from '@/pages/ai-product-page/partials/ai-upload/modals/partials/AiAuthForm.vue';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

const isOpen = defineModel<boolean>('open');

/**
 * photo-picker-requested rides the submit tap itself and must reach the page synchronously — see
 * requestPhotoPicker in AiAuthForm. Nothing may be awaited on the way through here.
 */
const emits = defineEmits<{ 'login-success': []; 'photo-picker-requested': [] }>();

const { t } = useI18n();

const step = ref<AiAuthStep>('email');

const title = computed(() => t(`pages.product_detail_page.ai_upload.auth.${step.value}.title`));

function onStepChange(newStep: AiAuthStep): void {
    step.value = newStep;
}

function onSuccess(): void {
    isOpen.value = false;
    emits('login-success');
}
</script>
